@use "/src/styles/functions";

.alert {
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    gap: functions.space(16);
    padding: functions.space(20);

    &[data-alignment="vertical"] {
      flex-direction: column;
      align-items: center;
    }
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: functions.space(16) functions.space(20);
    gap: functions.space(12);
    border-top: 1px solid functions.getColor(var(--theme-stroke-soft-200));
  }

  &__mainActions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: functions.space(12);
    flex-grow: 1;
  }

  &__content {
    display: flex;
    gap: functions.space(6);
    flex-direction: column;
    flex-grow: 1;

    &[data-alignment="vertical"] {
      align-items: center;
      text-align: center;
    }
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.5rem;
    height: 2.5rem;
    flex: 0 0 auto;
    border-radius: functions.radius(10);

    &[data-variant="information"] {
      background-color: functions.getColor(
        var(--theme-state-information-lighter)
      );
    }
    &[data-variant="error"] {
      background-color: functions.getColor(var(--theme-state-error-lighter));
    }
    &[data-variant="warning"] {
      background-color: functions.getColor(var(--theme-state-warning-lighter));
    }
    &[data-variant="success"] {
      background-color: functions.getColor(var(--theme-state-success-lighter));
    }
  }

  &__grow {
    flex-grow: 1;
  }
}
